import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/longterm2008.css';
import BgTop from '../images/Event/longterm2008/bg_top.png';
import BgMiddle from '../images/Event/longterm2008/bg_middle.png';
import BtnTab1 from '../images/Event/longterm2008/btn_tab_1.png';
import BtnTab2 from '../images/Event/longterm2008/btn_tab_2.png';

class Longterm2008 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0
    };
  }

  componentDidMount() {
    window.pageVisit("longterm", "2008");
    window.addEventListener("scroll", this.onScroll);
  }

  onScroll = (e) => {
    const scrollTop = ("scroll", e.srcElement.scrollingElement.scrollTop);
    this.setState({scrollTop: scrollTop});
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont longterm">
              <div id="contents">
                <div><img src={BgTop} style={{width: '100%'}} /></div>
                <div>
                  <img src={BtnTab1} style={{width: "50%", float: "left", backgroundColor: "red"}} />
                  <Link to="/event/miracle/2008"><img src={BtnTab2} style={{width: "50%"}} /></Link>
                </div>
                <div><img src={BgMiddle} style={{width: '100%'}} /></div>
              </div>
              <Link to="/event/branch/87" className={`banner ${this.state.scrollTop > 500 ? "show" : ""}`} onClick={() => window.pageComplete("longterm", "2008")}></Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Longterm2008;